namespace Portico.Models.Pdf {
    export enum XFontStyle {
        Regular = 0,
        Bold = 1,
        Italic = 2,
        BoldItalic = Italic | Bold,
        Underline = 4,
        Strikeout = 8
    }
 }